export default "__VITE_ASSET__D07Z4qp1__"